export default __webpack_public_path__ + "static/media/goArrowActive.e94d2153.svg";